<template>
  <div class="invoice-detail">
    <h3>发票详情</h3>
    <div class="cl">
      <div class="mod fl">
        <h4>开票明细</h4>
        <dl class="cl">
          <dt class="fl">开票金额-爱赛</dt>
          <dd>{{ invoiceData.aiSaiAmount }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">开票金额-用工无忧</dt>
          <dd>{{ invoiceData.wuYouAmount }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">开票金额-东绩</dt>
          <dd>{{ invoiceData.dongJiAmount }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">申请时间</dt>
          <dd>{{ invoiceData.createTime }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">发票类型</dt>
          <dd>{{ map.invoice.type[invoiceData.invoiceType] }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">发票抬头</dt>
          <dd>{{ invoiceData.enterprise }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">纳税人识别号</dt>
          <dd>{{ invoiceData.taxpayerId }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">开户银行</dt>
          <dd>{{ invoiceData.bank }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">银行帐号</dt>
          <dd>{{ invoiceData.bankCardNo }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">公司注册地址</dt>
          <dd>{{ invoiceData.registeredAddress }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">公司电话</dt>
          <dd>{{ invoiceData.registeredPhone }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">一般纳税人证明</dt>
          <dd>
            <a
              v-if="invoiceData.generalTaxpayerStatus"
              :href="invoiceData.generalTaxpayerStatus"
              target="_blank"
            >
              <img :src="invoiceData.generalTaxpayerStatus" width="200" />
            </a>
          </dd>
        </dl>
      </div>
      <div class="mod fl">
        <h4>邮寄信息</h4>
        <dl class="cl">
          <dt class="fl">收件人姓名</dt>
          <dd>{{ invoiceData.recipientName }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">收件人电话</dt>
          <dd>{{ invoiceData.recipientPhone }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">收件地址</dt>
          <dd>{{ invoiceData.mailingAddress }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">邮箱</dt>
          <dd>{{ invoiceData.recipientEmail }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">发票开具结果</dt>
          <dd>{{ invoiceData.trackingNumber }}</dd>
        </dl>
      </div>
    </div>
    <div>
      <h4>关联账单</h4>
      <el-table :data="invoiceData.invoiceBillings" size="mini">
        <el-table-column
          prop="orderBillingId"
          label="结算单号"
        ></el-table-column>
        <el-table-column
          prop="billingId"
          label="结算单编号"
          width="250"
        ></el-table-column>
        <el-table-column
          prop="contractTitle"
          label="合同名称"
        ></el-table-column>
        <el-table-column prop="amount" label="结算金额/元"></el-table-column>
        <el-table-column prop="actuallyPaid" label="实付金额">
        </el-table-column>
        <el-table-column prop="billSubject" label="开票主体">
          <template slot-scope="scope">{{
            map.invoice.billSubject[scope.row.billSubject]
          }}</template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="结算时间"
          width="150"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from "../api";
import map from "../../datamap";
const { invoice } = api;

import moment from "moment";

export default {
  name: "invoiceDetail",
  data() {
    return {
      map,
      invoiceData: {},
    };
  },
  computed: {
    invoiceId() {
      return this.$route.params.id;
    },
  },
  watch: {},
  methods: {
    async fetch(num) {
      let obj = {
        invoiceId: this.invoiceId,
      };
      let res = await invoice.detail(obj);
      this.invoiceData = res.data.data;
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
.invoice-detail .mod {
  width: 50%;
  font-size: 14px;
}
.invoice-detail .mod dt {
  width: 120px;
}
</style>


// WEBPACK FOOTER //
// src/views/invoice/detail.vue